let initialized = false;

const GA_ID = process.env.REACT_APP_GA_ID;
const GA_DEBUG = process.env.REACT_APP_GA_DEBUG === 'true';

function loadScript(src: string) {
  return new Promise<void>((resolve, reject) => {
    const el = document.createElement('script');
    el.async = true;
    el.src = src;
    el.onload = () => resolve();
    el.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(el);
  });
}

export async function initAnalytics(): Promise<boolean> {
  if (initialized) return true;
  if (!GA_ID) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.info('[analytics] REACT_APP_GA_ID not set; analytics disabled');
    }
    return false;
  }

  // Initialize dataLayer and gtag function
  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    (window as any).dataLayer.push(args);
  }
  (window as any).gtag = gtag;

  try {
    await loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
    gtag('js', new Date());
    if (GA_DEBUG) {
      gtag('config', GA_ID, { debug_mode: true });
    } else {
      gtag('config', GA_ID);
    }
    initialized = true;
    if (GA_DEBUG) {
      // Emit a test event to show up in DebugView
      (window as any).gtag('event', 'debug_ping', { debug_mode: true });
    }
    return true;
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[analytics] Failed to load GA script', e);
    }
    return false;
  }
}

export function trackPageview(path: string, title?: string) {
  if (!initialized || !GA_ID) return;
  (window as any).gtag('event', 'page_view', {
    page_title: title || document.title,
    page_location: window.location.href,
    page_path: path,
    ...(GA_DEBUG ? { debug_mode: true } : {})
  });
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (!initialized || !GA_ID) return;
  (window as any).gtag('event', eventName, {
    ...(params || {}),
    ...(GA_DEBUG ? { debug_mode: true } : {})
  });
}
